import { render } from "./JobStack.vue?vue&type=template&id=0cb920bc"
import script from "./JobStack.vue?vue&type=script&lang=js"
export * from "./JobStack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__